export interface IOccupations {
  code: string;
  name: string;
  class: string;
  diiClass: string;
}
export const Occupations: IOccupations[] = [
  {
    code: "A415",
    name: "Abattoir Inspector",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A416",
    name: "Abattoir Worker",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A417",
    name: "Account Executive",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A418",
    name: "Account Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A000",
    name: "Accountant / Accounts Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A419",
    name: "Accounts Admin/Assistant",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A002",
    name: "Actor/Actress - No Stunt Work",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A003",
    name: "Actor/Actress -With Stunt Work",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A004",
    name: "Actuary",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A001",
    name: "Acupuncturist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A420",
    name: "Administration Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A006",
    name: "Administration/Clerical Worker",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A421",
    name: "Administrator - Office",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A422",
    name: "Advertising Executive",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A423",
    name: "Advertising Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A007",
    name: "Advertising Staff/Professional",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A424",
    name: "Aerial Erector - Hgts <15 mtrs",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A425",
    name: "Aerial Erector - Hgts >15 mtrs",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A426",
    name: "Aerobics Instructor",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A427",
    name: "Agricultural Engineer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A428",
    name: "Agricultural Worker",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A009",
    name: "Air Con Worker - Hgts <15 mtrs",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A010",
    name: "Air Con Worker - Hgts >15 mtrs",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A011",
    name: "Air Traffic Controller",
    class: "CLS2",
    diiClass: "CLS1"
  },
  {
    code: "A429",
    name: "Air Traffic Planner",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A012",
    name: "Aircraft - Fitter/Technician",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A014",
    name: "Aircraft - Loader/Bag Handler",
    class: "CLS2",
    diiClass: "CLS4"
  },
  {
    code: "A013",
    name: "Aircraft - Maintenance",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A430",
    name: "Aircraft Inspector",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A431",
    name: "Aircraft Instrument Mechanic",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A432",
    name: "Aircraft Marshaller",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A433",
    name: "Aircraft Refueller",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A434",
    name: "Airport Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A435",
    name: "Airport Superintendent",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A436",
    name: "Amusement Arcade Worker",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A437",
    name: "Amusement Park Worker",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A438",
    name: "Anaesthetist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A439",
    name: "Analyst - Business",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A440",
    name: "Analyst - City",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A441",
    name: "Analyst - Investment",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A442",
    name: "Analyst - Systems/IT",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A018",
    name: "Animal Health Inspector",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A443",
    name: "Animal Nursing Auxiliary",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A444",
    name: "Animal Trainer/Keeper",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A017",
    name: "Animal Welfare Officer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A019",
    name: "Animator",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A445",
    name: "Antique Dealer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A446",
    name: "Antique Restorer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A447",
    name: "Application Developer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A448",
    name: "Archaeologist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A021",
    name: "Architect / Architectural Work",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A022",
    name: "Archivist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A024",
    name: "Armed Forces - Bomb Disposal",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A449",
    name: "Armed Forces - Commando",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A023",
    name: "Armed Forces - Office Based",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A025",
    name: "Army Officer / Naval Officer",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A026",
    name: "Art Dealer / Antique Dealer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A450",
    name: "Art Director",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A451",
    name: "Art Gallery Attendant",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A452",
    name: "Art Gallery Curator",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A453",
    name: "Art Gallery Guide",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A454",
    name: "Art Gallery Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A455",
    name: "Artificial Intelligence Specialist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A456",
    name: "Artist - Freelance Painter",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A027",
    name: "Artist - Non-Salaried",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A028",
    name: "Artist - Salaried",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A029",
    name: "Assembler - Aircraft",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A030",
    name: "Assembler - Other",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A457",
    name: "Assistant Editor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A458",
    name: "Astrologer",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A032",
    name: "Attendant/Orderly - Medical",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A033",
    name: "Auctioneer ",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A034",
    name: "Auctioneering Services",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A459",
    name: "Audiometrician",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A460",
    name: "Auditor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A035",
    name: "Author - Non-Salaried",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A036",
    name: "Author - Salaried",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A037",
    name: "Automotive Electrician ",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A038",
    name: "Automotive Technician",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A461",
    name: "Baggage/Luggage Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A462",
    name: "Baggage/Luggage Porter",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A039",
    name: "Baker / Bakery Worker",
    class: "CLS1",
    diiClass: "CLS3"
  },
  {
    code: "A463",
    name: "Bakery Shop Manager",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A040",
    name: "Banking Professional / Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A464",
    name: "Bar Manager/Owner",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A042",
    name: "Barber",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A465",
    name: "Bargeman - Quarrying",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A043",
    name: "Bargeman / Barge Operator",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A466",
    name: "Barista",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A467",
    name: "Barrister",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A468",
    name: "Barrister, Advocate",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A044",
    name: "Bartender / Bar Worker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A045",
    name: "Beautician / Beauty Therapist",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A469",
    name: "Beauty Salon Manager/Owner",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A470",
    name: "Beekeeper/Apiarist",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A471",
    name: "Behavioral Research Analyst",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A046",
    name: "Bellboy / Bell Captain",
    class: "CLS1",
    diiClass: "CLS3"
  },
  {
    code: "A472",
    name: "Bicycle Delivery",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A473",
    name: "Bill Poster/Sticker",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A474",
    name: "Biochemist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A475",
    name: "Biochemist - Research",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A476",
    name: "Biological Scientist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A477",
    name: "Biologist - No Travel/Underwater",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A478",
    name: "Biologist - Underwater Work",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A479",
    name: "Biscuit Baker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A480",
    name: "Blacksmith",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A481",
    name: "Bleacher - Paper & Board",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A482",
    name: "Bleacher - Textile & Clothing",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A047",
    name: "Blind / Curtain Fitter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A483",
    name: "Boarding Sch/Hostel Matron",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A048",
    name: "Boat Builder",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A049",
    name: "Boatman / Ferryman",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A050",
    name: "Boatswain / Bosun",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A051",
    name: "Body Guard",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A052",
    name: "Boiler Maker / Boilerman",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A053",
    name: "Book Binder",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A484",
    name: "Book Illustrator",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A485",
    name: "Bookkeeper",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A486",
    name: "Bookseller",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A487",
    name: "Botanist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A054",
    name: "Bouncer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A488",
    name: "Box Office Cashier",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A489",
    name: "Box Office Clerk",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A490",
    name: "Box Office Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A491",
    name: "Brazer",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A492",
    name: "Bread Baker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A493",
    name: "Breakdown Recovery Man",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A055",
    name: "Brewer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A494",
    name: "Brewery Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A056",
    name: "Bricklayer / Blocklayer",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A057",
    name: "Broadcasting Technician",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A495",
    name: "Broker - Financial Instruments",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A496",
    name: "Broker - Insurance IFA",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A497",
    name: "Broker - Insurance Non IFA",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A498",
    name: "Building Inspector",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A059",
    name: "Building Maintenance Worker",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A499",
    name: "Bus Conductor/Inspector",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A500",
    name: "Business Development Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A501",
    name: "Business Intelligence Analyst",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A502",
    name: "Business Transformation Consultant",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A060",
    name: "Butcher - Abattoir/Meat Works",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A061",
    name: "Butcher - Market",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A503",
    name: "Butler",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A504",
    name: "Buyer - Stocks/Shares (Salaried)",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A505",
    name: "Buyer/Purchaser",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A063",
    name: "Cabin Crew / Flight Attendant",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A506",
    name: "Cable Laying Diver",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A507",
    name: "Cafe Cashier",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A508",
    name: "Cafe Manager",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A509",
    name: "Cafe Worker",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A064",
    name: "Cafeteria / Canteen Assistant",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A510",
    name: "Calibrator",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A511",
    name: "Call Centre - Officer/Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A512",
    name: "Call Centre - Telesales",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A513",
    name: "Calligrapher",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A514",
    name: "Cameraman - Non Disaster/War Zone",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A515",
    name: "Canteen Manager",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A069",
    name: "Car Dealer / Salesman",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A516",
    name: "Car Park Attendant",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A517",
    name: "Car Rental Company Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A518",
    name: "Car Rental Company Worker",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A519",
    name: "Car Valeter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A520",
    name: "Careers Advisor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A071",
    name: "Caretaker / Janitor",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A521",
    name: "Cargo/ Freight Clerk",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A522",
    name: "Carpenter - Construction",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A072",
    name: "Carpenter / Joiner",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A523",
    name: "Carpet Fitter",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A524",
    name: "Cartographer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A525",
    name: "Cartoonist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A526",
    name: "Carwash Attendant",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A073",
    name: "Cashier",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A074",
    name: "Casino/Gaming/Gambling Worker",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A527",
    name: "Catering Manager",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A075",
    name: "Catering Staff",
    class: "CLS3",
    diiClass: "CLS2"
  },
  {
    code: "A528",
    name: "Caulker",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A529",
    name: "Ceiling Fixer",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A530",
    name: "Charity Worker - Admin",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A531",
    name: "Chemical Engineer - Industrial",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A532",
    name: "Chemical Engineer - Offshore",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A076",
    name: "Chemical Handler/Process Work",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A533",
    name: "Chemical Plumber",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A534",
    name: "Chemist - Industrial",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A535",
    name: "Chemist - Retail",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A536",
    name: "Child Protection Co-ordinator",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A537",
    name: "Child Welfare Officer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A538",
    name: "Childcare Teacher - Qualified",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A539",
    name: "Chinese Medicine Practitioner",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A540",
    name: "Chiropodist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A412",
    name: "Chiropractor",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A079",
    name: "Choreographer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A080",
    name: "Cinema Cashier / Attendant",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A081",
    name: "Cinema Projectionist",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A082",
    name: "Civil Defence Emergency Worker",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A541",
    name: "Civil Servant - Office Based",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A542",
    name: "Claims Adjuster",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A543",
    name: "Claims Assessor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A084",
    name: "Cleaner - Domestic",
    class: "CLS2",
    diiClass: "CLS4"
  },
  {
    code: "A086",
    name: "Cleaner - Industrial ",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A085",
    name: "Cleaner - Office / Transport",
    class: "CLS2",
    diiClass: "CLS4"
  },
  {
    code: "A087",
    name: "Cleaner - Window",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A088",
    name: "Clergyman",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A544",
    name: "Client Relationship Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A545",
    name: "Client Service Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A546",
    name: "Cloakroom Attendant",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A547",
    name: "Clock/Watch Assembler",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A548",
    name: "Clock/Watch Repairer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A549",
    name: "Cloth Cutter",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A550",
    name: "Coastguard - Office Based",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A551",
    name: "Coffin Maker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A552",
    name: "Columnist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A553",
    name: "Comedian",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A554",
    name: "Commentator - Non Disaster/War",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A089",
    name: "Community Health Worker",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A555",
    name: "Company Director - Salaried",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A556",
    name: "Company Secretary",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A557",
    name: "Compliance Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A090",
    name: "Composer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A091",
    name: "Compositor",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A558",
    name: "Computer Operator",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A559",
    name: "Computer Programmer/Analyst",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A092",
    name: "Computer Repairer/Technician",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A560",
    name: "Computer Software Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A561",
    name: "Computer Systems Installer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A093",
    name: "Concrete / Stone Worker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A562",
    name: "Conductor - Music",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A563",
    name: "Confectioner",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A564",
    name: "Conference Organising Assistant",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A565",
    name: "Conference Organising Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A095",
    name: "Conservator - Art Works",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A096",
    name: "Construction - Hgts < 15 mtrs",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A097",
    name: "Construction - Hgts > 15 mtrs",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A098",
    name: "Container Ship / Tanker - Crew",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A099",
    name: "Container Ship/Tanker -Officer",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A100",
    name: "Control Room Operator - Power",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A101",
    name: "Cook / Chef (Head Chef)",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A102",
    name: "Copywriter",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A566",
    name: "Coroner",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A567",
    name: "Costume Designer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A103",
    name: "Counsellor",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A104",
    name: "Courier - Bicycle / Motorcycle",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A105",
    name: "Courier - Car / Van",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A568",
    name: "Court Bailiff",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A569",
    name: "Court Usher",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A106",
    name: "Craftsman",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A107",
    name: "Crane Driver - Construction",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A570",
    name: "Crane Driver - Docks/Shipyard",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A571",
    name: "Crane Operator - Control Room ",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A572",
    name: "Credit Controller",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A110",
    name: "Crematorium Operator / Worker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A111",
    name: "Cruise Liner - Crew",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A112",
    name: "Cruise Liner - Officer",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A113",
    name: "Curator",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A573",
    name: "Customer Analystics Profession",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A574",
    name: "Customer Care Officer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A575",
    name: "Customer Service Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A114",
    name: "Customs / Immigration Staff (non-uniformed)",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A115",
    name: "Cutter - Block / Flame / Glass",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A116",
    name: "Cutter - Design or Pattern",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A576",
    name: "Dancer - Entertainment",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A118",
    name: "Dancer - Professional",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A577",
    name: "Dancing/Drama Teacher - Private",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A578",
    name: "Data Analyst/Scientist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A579",
    name: "Data Controller",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A580",
    name: "Data Inputter",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A119",
    name: "Debt Collector - Non Office",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A120",
    name: "Debt Collector - Office Based",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A122",
    name: "Demolition Work - Explosives",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A121",
    name: "Demolition Work -No Explosives",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A123",
    name: "Dental Assistant/ Nurse ",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A581",
    name: "Dental Hygienist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A582",
    name: "Dental Technician",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A125",
    name: "Dental Therapist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A124",
    name: "Dentist / Dental Surgeon",
    class: "CLS1",
    diiClass: "CLS3"
  },
  {
    code: "A583",
    name: "Department Store Manager",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A584",
    name: "Department Store Worker",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A585",
    name: "Dermatologist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A586",
    name: "Detention Centre Warden",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A587",
    name: "Die Cutter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A588",
    name: "Die Setter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A126",
    name: "Dietician / Nutritionist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A589",
    name: "Digital Marketing Profession",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A590",
    name: "Digital Specialist/Analyst",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A591",
    name: "Diplomat",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A592",
    name: "Director - Heavy Manual Duties",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A593",
    name: "Director - Light Manual Duties",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A594",
    name: "Director - Management Duties",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A595",
    name: "Director - Musical",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A596",
    name: "Director - TV/Film",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A129",
    name: "Disc Jockey",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A597",
    name: "Distiller",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A598",
    name: "Distillery Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A130",
    name: "Diver - Armed Forces",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A133",
    name: "Diver - Instructor",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A131",
    name: "Diver - Other No Explosives",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A132",
    name: "Diver - Other With Explosives",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A599",
    name: "Dock Foreman",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A600",
    name: "Dock Master",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A601",
    name: "Dock Superintendent",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A134",
    name: "Docker / Dock Worker",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A135",
    name: "Doctor - Medical / Specialist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A136",
    name: "Doctor - Surgeon",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A602",
    name: "Document Management Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A137",
    name: "Domestic Worker",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A139",
    name: "Drain Layer",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A603",
    name: "Drainage Layer/Clearer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A140",
    name: "Draughtsman",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A141",
    name: "Dredgerman / Dredger Driver",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A604",
    name: "Drier - Food",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A605",
    name: "Driller - Oil &Gas (Offshore)",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A606",
    name: "Driller - Onshore",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A142",
    name: "Driver - Ambulance",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A607",
    name: "Driver - Bulldozer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A143",
    name: "Driver - Bus / Coach / Van",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A144",
    name: "Driver - Chauffeur / Limousine",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A608",
    name: "Driver - Construction",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A609",
    name: "Driver - Excavator",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A145",
    name: "Driver - MRT / Train",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A610",
    name: "Driver - Pile",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A611",
    name: "Driver - Private Hire",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A612",
    name: "Driver - Refuse",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A146",
    name: "Driver - Taxi",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A613",
    name: "Driver - Tractor",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A614",
    name: "Driver - Tram",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A147",
    name: "Driver - Truck/Heavy Goods ",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A148",
    name: "Driver/Operator - Earthmoving ",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A149",
    name: "Driving Instructor / Examiner",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A615",
    name: "Dustman/Refuse Collector",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A616",
    name: "Dyer - Textile",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A150",
    name: "Economist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A151",
    name: "Editor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A617",
    name: "Electric Logger",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A618",
    name: "Electrical Contractor",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A619",
    name: "Electrical Engineer",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A620",
    name: "Electrical Fitter",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A152",
    name: "Electrical Supply Worker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A621",
    name: "Electrical Wireman",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A154",
    name: "Electrician - Domestic ",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A155",
    name: "Electrician - Office Premises",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A622",
    name: "Electrician - Offshore",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A153",
    name: "Electrician - Other",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A623",
    name: "Electronics Fitter",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A624",
    name: "Electronics Installer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A625",
    name: "Electronics Mechanic",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A626",
    name: "Electronics Repairer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A627",
    name: "Electronics Service Mechanic",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A628",
    name: "Electronics Wireman",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A156",
    name: "Electroplater",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A157",
    name: "Embalmer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A629",
    name: "Employment Agency Owner - Admin",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A630",
    name: "Employment Agency Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A631",
    name: "Enameller - Metals",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A632",
    name: "Engine Tester",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A633",
    name: "Engineer - Admin/Site Visits",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A634",
    name: "Engineer - Hgts > 15 mtrs",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A635",
    name: "Engineer - Sales",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A159",
    name: "Engineer/Techn - Construction",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A161",
    name: "Engineer/Techn - Offshore",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A162",
    name: "Engineer/Techn - Oil Rig",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A158",
    name: "Engineer/Techn- Admin/Research",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A160",
    name: "Engineer/Technician - Other",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A163",
    name: "Engraver",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A164",
    name: "Entertainer",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A636",
    name: "Entertainment Agent",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A637",
    name: "Entertainment Manager",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A165",
    name: "Environmental Health Worker",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A638",
    name: "Equestrian - Riding Instructor",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A639",
    name: "Equipment Cleaner - No Hgts Involved",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A640",
    name: "Erector-Metal Manufacture (<15 mtrs)",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A641",
    name: "Erector-Metal Manufacture (>15 mtrs)",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A642",
    name: "Estate Manager - No Manual Work",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A643",
    name: "Estate Planner - Comm-based",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A644",
    name: "Etcher - Printing Industry",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A166",
    name: "Events Planner",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A645",
    name: "Exhaust Fitter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A646",
    name: "Exhausterman",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A167",
    name: "Exhibition Coordinator",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A647",
    name: "Exhibition Stand Fitter",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A648",
    name: "Explosives Inspector",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A168",
    name: "Explosives Worker / Blaster",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A649",
    name: "Export Agent",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A650",
    name: "Fabric Designer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A651",
    name: "Factory Inspector",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A652",
    name: "Factory Manager - Admin",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A169",
    name: "Factory Worker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A653",
    name: "Farm Manager - Manual Duties",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A654",
    name: "Farm Manager - No Manual Duties",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A655",
    name: "Farm Owner - Manual Duties",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A656",
    name: "Farm Owner - No Manual Duties",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A657",
    name: "Farm Worker/Labourer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A658",
    name: "Farmer - Manual Duties",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A659",
    name: "Farrier",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A660",
    name: "Fashion Designer/Stylist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A661",
    name: "Fast Food Restaurant Assistant",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A662",
    name: "Fast Food Restaurant Manager - Admin",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A663",
    name: "Fencing Contractor",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A171",
    name: "Film Critic",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A041",
    name: "Finance Professional / Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A664",
    name: "Financial Paraplanner - Salaried",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A665",
    name: "Financial Planner - Comm-based",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A173",
    name: "Fireman / Fire Fighter",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A174",
    name: "Fisher Farmer/Worker - Onshore",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A175",
    name: "Fisherman / Fishing Boat Crew",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A176",
    name: "Fishmonger",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A369",
    name: "Fitness - Instructor/Trainer",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A666",
    name: "Fitter - Motor Vehicle & Cycle",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A177",
    name: "Fitter / Turner",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A667",
    name: "Fitter - Assembler",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A668",
    name: "Fixer Mason",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A669",
    name: "Flight Dispatcher",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A670",
    name: "Flight Operations Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A671",
    name: "Flight Planner",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A178",
    name: "Floor Layer",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A672",
    name: "Floorman - Oil Rig",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A179",
    name: "Florist",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A673",
    name: "Flour Confectioner",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A180",
    name: "Food Preparation Worker",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A674",
    name: "Food Technologist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A675",
    name: "Footballer Manager",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A182",
    name: "Foreman/Supervis - Agriculture",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A183",
    name: "Foreman/Supervis -Construction",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A184",
    name: "Foreman/Supervis-Dock/Shipyard",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A181",
    name: "Foreman/Supervisor - Admin ",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A185",
    name: "Foreman/Supervisor - Offshore",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A186",
    name: "Foreman/Supervisor - Oil Rig",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A187",
    name: "Foreman/Supervisor - Onshore",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A189",
    name: "Foreman/Supervisor - Other",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A190",
    name: "Foreman/Supervisor - Printing",
    class: "CLS1",
    diiClass: "CLS3"
  },
  {
    code: "A188",
    name: "Foreman/Supervisor - Utilities",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A676",
    name: "Forest Ranger",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A677",
    name: "Forestry Officer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A191",
    name: "Forklift Driver",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A678",
    name: "Fortune Teller",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A679",
    name: "Frame Finisher",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A192",
    name: "Freezing Worker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A680",
    name: "Freight Manager - Airport",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A681",
    name: "Freight Manager - Docks",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A682",
    name: "French Polisher",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A683",
    name: "Fuel Technologist",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A684",
    name: "Funeral Director",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A685",
    name: "Funeral Director''s Assistant",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A686",
    name: "Furnace Control Room Operator",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A193",
    name: "Furnaceman / Furnace Operator",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A687",
    name: "Furniture Designer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A194",
    name: "Furniture Maker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A195",
    name: "Furniture Mover / Packer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A688",
    name: "Furniture Restorer",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A689",
    name: "Furniture Retailer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A690",
    name: "Gallery Owner",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A196",
    name: "Gallery Worker",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A691",
    name: "Galvaniser",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A692",
    name: "Gameplayer Programmer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A693",
    name: "Gantry Crane Driver",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A694",
    name: "Garage - Mechanic",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A695",
    name: "Garage Owner - Admin",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A696",
    name: "Garage Supervisor - Manual Work",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A197",
    name: "Garbage Collector / Disposer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A198",
    name: "Gardener",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A697",
    name: "Gas Appliance Mechanic",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A698",
    name: "Gas Compressor Operator",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A199",
    name: "Gas Cylinder Filler",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A200",
    name: "Gas Fitter / Tester",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A699",
    name: "Gas Meter Tester",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A700",
    name: "Gem Cutter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A701",
    name: "Gem Polisher",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A702",
    name: "Gem Setter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A703",
    name: "Geologist - Oil & Gas (Offshore)",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A704",
    name: "Geologist - Oil & Gas (Onshore)",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A705",
    name: "Geophysicist - Oil & Gas (Onshore)",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A201",
    name: "Glass Worker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A202",
    name: "Glazier",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A706",
    name: "Goldsmith",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A707",
    name: "Golf - Caddie",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A203",
    name: "Graphic Designer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A204",
    name: "Grave Digger",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A708",
    name: "Grinder - Metal",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A709",
    name: "Grocer  - Retail",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A710",
    name: "Ground Equipment Mechanic",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A711",
    name: "Groundsman",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A712",
    name: "Guard - Railway",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A205",
    name: "Hairstylist / Hairdresser",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A713",
    name: "Handyman",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A714",
    name: "Harbour Master",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A715",
    name: "Hardware Shop Retailer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A206",
    name: "Hatchery Worker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A207",
    name: "Hawker / Stall holder",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A716",
    name: "Head Roustabout - Oil & Gas",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A717",
    name: "Health & Fitness Club Manager - Admin",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A718",
    name: "Health & Safety Officer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A719",
    name: "Healthcare Assistant",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A208",
    name: "Heavy Vessel - Crew / Officer",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A720",
    name: "Helicopter Engineer",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A721",
    name: "Helicopter Pilot - Oil Rig",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A722",
    name: "Helicopter Pilot - Onshore",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A209",
    name: "Historian",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A210",
    name: "Hoist Operator",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A211",
    name: "Homeopath / Naturopath",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A723",
    name: "Horse Breeder",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A212",
    name: "Horticulturalist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A724",
    name: "Hospital Matron",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A725",
    name: "Hospital Porter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A726",
    name: "Hospital Storeman",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A727",
    name: "Hospital Ward Orderly",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A728",
    name: "Hostess - Entertainment",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A729",
    name: "Hotel Detective",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A730",
    name: "Hotel Manager - Office Based",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A731",
    name: "Hotel Porter",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A213",
    name: "Hotel Worker - Bellboy/Bellhop",
    class: "CLS1",
    diiClass: "CLS3"
  },
  {
    code: "A214",
    name: "Hotel Worker -Concierge/Porter",
    class: "CLS1",
    diiClass: "CLS3"
  },
  {
    code: "A215",
    name: "House Husband",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A216",
    name: "Housekeeper",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A217",
    name: "Housewife",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A732",
    name: "Human Resources Director",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A218",
    name: "Human Resources Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A733",
    name: "Hygienist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A734",
    name: "Hypnotherapist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A735",
    name: "Imam",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A736",
    name: "Incinerator Operator",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A737",
    name: "Industrial Relations Officer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A738",
    name: "Industrial Trainer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A739",
    name: "Inseminator",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A219",
    name: "Inspector - Quality / Safety",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A220",
    name: "Installation Fitter",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A221",
    name: "Instrument Maker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A740",
    name: "Instrument Repairer/Fitter",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A222",
    name: "Insulation Worker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A741",
    name: "Insurance Agent",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A742",
    name: "Insurance Assessor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A743",
    name: "Insurance Inspector",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A223",
    name: "Insurance Professional / Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A224",
    name: "Interior Decorator / Designer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A744",
    name: "Internal Auditor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A225",
    name: "Interpreter - No Overseas Work",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A745",
    name: "Ironer",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A746",
    name: "IT Consultant",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A747",
    name: "IT Helpdesk Support",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A748",
    name: "IT Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A749",
    name: "IT Programmer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A229",
    name: "IT Systems Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A750",
    name: "IT Technician",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A230",
    name: "Jeweller",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A751",
    name: "Jewellery Enameller",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A752",
    name: "Jewellery Making & Repair",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A753",
    name: "Jewellery Mounter",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A231",
    name: "Jewellery/Precious Metal Work",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A232",
    name: "Jockey",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A754",
    name: "Joiner - Construction",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A755",
    name: "Joiner - Metals",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A756",
    name: "Joiner - Ship & Marine Engineering",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A757",
    name: "Journalism Researcher - Non Disaster/War Zone",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A758",
    name: "Journalist - Non Disaster/War Zone",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A759",
    name: "Judge",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A760",
    name: "Judge''s Clerk",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A761",
    name: "Justice of the Peace",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A236",
    name: "Juvenile",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A237",
    name: "Keeper - Zoo / Bird / Aquatic",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A762",
    name: "Kennel Assistant/Hand",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A763",
    name: "Kerb Layer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A764",
    name: "Key Cutter",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A238",
    name: "Kitchen Assistant / Hand",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A765",
    name: "Laboratory Manager - Supervisory",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A766",
    name: "Laboratory Technician",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A239",
    name: "Labourer / Manual Worker",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A767",
    name: "Laminator",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A768",
    name: "Land Drainage Worker",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A240",
    name: "Landscape Architect / Artist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A769",
    name: "Landscape Gardener",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A770",
    name: "Landscape Painter - Salaried",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A242",
    name: "Lashing Worker",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A771",
    name: "Lathe Operator",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A243",
    name: "Launderer / Dry Cleaner",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A772",
    name: "Launderette Assistant",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A773",
    name: "Laundryman",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A774",
    name: "Lawyer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A775",
    name: "Leather Worker",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A244",
    name: "Lecturer / Professor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A776",
    name: "Legal Advisor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A777",
    name: "Legal Executive",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A778",
    name: "Legal Practice Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A779",
    name: "Legal Secretary",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A245",
    name: "Legal Staff / Professional",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A246",
    name: "Librarian / Library Assistant",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A780",
    name: "Life Coach - Salaried",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A247",
    name: "Life Guard",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A248",
    name: "Lift / Escalator Fitter",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A781",
    name: "Lift Attendant",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A782",
    name: "Lift Engineer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A783",
    name: "Lift Erector",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A784",
    name: "Lighting Manager",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A785",
    name: "Lighting Technician",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A249",
    name: "Linesman - Electrical Supply",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A786",
    name: "Liquidator",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A787",
    name: "Literary Agent",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A250",
    name: "Lithographer ",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A252",
    name: "Loader",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A253",
    name: "Locksmith",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A788",
    name: "Loss Adjuster",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A254",
    name: "Machine Fitter /Machine Setter",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A789",
    name: "Machine Learning Engineer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A255",
    name: "Machine Operator - Engy/Utilit",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A256",
    name: "Machine Operator - Ship Build",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A257",
    name: "Machine Operator / Machinist",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A790",
    name: "Magazine Editor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A791",
    name: "Magazine Illustrator",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A792",
    name: "Magazine Writer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A793",
    name: "Magician",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A258",
    name: "Mail Sorter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A794",
    name: "Maintenance Fitter",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A795",
    name: "Maintenance Manager",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A796",
    name: "Maintenance Repairer",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A797",
    name: "Maintenance Technician",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A259",
    name: "Maintenance Worker - Utilities",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A798",
    name: "Maitre d''Hotel",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A799",
    name: "Make-up Artist - Non-Salaried",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A800",
    name: "Make-up Artist - Salaried",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A801",
    name: "Management Consultant/Associate",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A260",
    name: "Manager - Administration",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A261",
    name: "Manager - Commercial/Retail",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A262",
    name: "Manager - Offshore / Oil Rig",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A263",
    name: "Manager - Other",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A264",
    name: "Managing Director / CEO",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A802",
    name: "Manicurist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A803",
    name: "Marine Biologist",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A804",
    name: "Marine Engineer",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A805",
    name: "Marine Installation Fitter",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A806",
    name: "Marine Surveyor",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A807",
    name: "Market Research Analyst",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A808",
    name: "Market Research Interviewer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A809",
    name: "Market Researcher - Office Based",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A810",
    name: "Marketing Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A265",
    name: "Marketing Professional / Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A811",
    name: "Martial Arts Instructor",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A266",
    name: "Masseur/Masseuse",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A005",
    name: "Mathematician/Statistician",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A267",
    name: "Mechanic",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A268",
    name: "Mechanic - Aircraft Engine",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A812",
    name: "Mechanical Engineer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A813",
    name: "Medical Secretary",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A269",
    name: "Metal Worker",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A270",
    name: "Metallurgist",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A814",
    name: "Meteorologist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A271",
    name: "Meter Fitter / Tester",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A272",
    name: "Meter Reader",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A815",
    name: "Midwife",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A816",
    name: "Mineralogist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A817",
    name: "Minister of Religion",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A273",
    name: "Missionary",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A818",
    name: "Mixer - Processing",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A274",
    name: "Model",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A275",
    name: "Money Changer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A819",
    name: "Monk/Nun",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A276",
    name: "Mortuary Worker",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A820",
    name: "Motor Bike Instructor",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A277",
    name: "Motorcycle Delivery",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A278",
    name: "Moulder / Mould Maker",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A821",
    name: "Museum Guide",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A279",
    name: "Museum Worker",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A822",
    name: "Music Teacher - Private",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A823",
    name: "Musical Instrument Repairer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A280",
    name: "Musician",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A281",
    name: "National Serviceman",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A282",
    name: "News Vendor",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A824",
    name: "Newspaper Reporter - Freelance",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A283",
    name: "Nightclub Staff / Manager",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A284",
    name: "Nightwatchman",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A825",
    name: "Nurse - Admin/Teaching",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A285",
    name: "Nurse / Nurse Assistant",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A826",
    name: "Nursery School Assistant",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A827",
    name: "Nurseryman",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A828",
    name: "Nursing Auxiliary",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A829",
    name: "Nursing Home Owner",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A286",
    name: "Occupational Health Worker",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A287",
    name: "Occupational Therapist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A830",
    name: "Office Clerk",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A831",
    name: "Office Fitter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A832",
    name: "Office Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A288",
    name: "Oil Rig / Off Shore Workers",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A289",
    name: "Oil Rig Vessel - Crew/Officer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A833",
    name: "Old People''s Home Matron",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A834",
    name: "Old People''s Home Warden",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A835",
    name: "Online Shopping Agents",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A836",
    name: "Operations Manager - Admin",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A837",
    name: "Optical Instrument Fitter",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A838",
    name: "Optical Instrument Maker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A839",
    name: "Optical Instrument Mechanic",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A840",
    name: "Optical Instrument Repairer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A290",
    name: "Optician / Ophthalmologist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A841",
    name: "Opticians Assistant",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A842",
    name: "Orchestrator",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A843",
    name: "Orthodontic Technician",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A844",
    name: "Orthodontist",
    class: "CLS1",
    diiClass: "CLS3"
  },
  {
    code: "A845",
    name: "Orthoptist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A846",
    name: "Osteopath",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "OT01",
    name: "Other-C1-D1 (Administrative and non manual work)",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "OT02",
    name: "Other-C2-D2 (Administrative / light manual work)",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "OT03",
    name: "Other-C3-D3 (Moderate amount of manual work/ outdoor work)",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "OT04",
    name: "Other-C4-D4 (Semi or unskilled/ moderate to mostly manual work)",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "OT49",
    name: "Other-C4-D9 (Semi/unskilled/ mostly manual work)",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A291",
    name: "Packer",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A847",
    name: "Painter - Exterior (Hgts <15 mtrs)",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A848",
    name: "Painter - Exterior (Hgts >15 mtrs)",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A849",
    name: "Painter/Decorator - Interior",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A293",
    name: "Panel Beater",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A294",
    name: "Paramedic",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A295",
    name: "Parking Enforcement Officer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A297",
    name: "Parks Officer / Park Ranger",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A850",
    name: "Parks Superintendent",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A296",
    name: "Parks/Garden Maintenance Work",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A851",
    name: "Pasteuriser",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A852",
    name: "Pathologist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A298",
    name: "Pattern Maker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A853",
    name: "Pawnbroker",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A854",
    name: "Pedicurist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A855",
    name: "Personal Assistant (PA)",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A299",
    name: "Pest Controller / Officer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A300",
    name: "Pet Breeder / Groomer",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A856",
    name: "Petrol Pump Attendant",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A413",
    name: "Pharmacist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A857",
    name: "Pharmacologist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A858",
    name: "Pharmacy Assistant",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A859",
    name: "Photographer - Non Disaster/War Zone",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A251",
    name: "Photolithographer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A860",
    name: "Physical Education Teacher",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A861",
    name: "Physicist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A302",
    name: "Physiotherapist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A862",
    name: "Piano/Organ Tuner",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A304",
    name: "Pilot - Airforce (Captain)",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A305",
    name: "Pilot - Airforce (Instructor)",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A306",
    name: "Pilot - Airforce (Lieutenant)",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A309",
    name: "Pilot - Airforce (Trainee)",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A303",
    name: "Pilot - Commercial Airline",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A310",
    name: "Pilot - Harbour / Marine",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A863",
    name: "Pilot - Non International Airline",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A312",
    name: "Pipe Fitter / Layer",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A313",
    name: "Plant Operator - Oil Refinery",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A314",
    name: "Plant Operator - Other",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A315",
    name: "Plant Operator-Water Treatment",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A316",
    name: "Plasterer",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A317",
    name: "Plastics Worker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A864",
    name: "Playwright",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A318",
    name: "Plumber / Plumbing Work",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A865",
    name: "Pneumatic Drill Operator",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A319",
    name: "Police Officer / Police Work",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A320",
    name: "Political Scientist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A866",
    name: "Politician",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A867",
    name: "Port Control Signalman",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A868",
    name: "Port Health Inspector",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A321",
    name: "Porter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A322",
    name: "Postman",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A323",
    name: "Pottery Worker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A324",
    name: "Poultry Worker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A325",
    name: "Presenter - Television / Radio",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A326",
    name: "Pressman",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A869",
    name: "Priest/Pastor/Reverend",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A327",
    name: "Printer / Machine Operator",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A870",
    name: "Printing Director - Admin",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A328",
    name: "Prison Officer / Warden",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A329",
    name: "Private Investigator",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A871",
    name: "Private Investor",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A330",
    name: "Probation Officer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A331",
    name: "Process Worker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A872",
    name: "Producer - TV/Film/Theatre (Non Disaster/War)",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A332",
    name: "Production Line Worker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A873",
    name: "Production Manager - Radio/TV",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A333",
    name: "Professional Sportsperson",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A874",
    name: "Project Co-ordinator",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A875",
    name: "Project Manager/Programme Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A876",
    name: "Prompter - Theatre",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A877",
    name: "Proofer - Printing Industry",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A878",
    name: "Property Manager - Maintenance",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A879",
    name: "Property/Real Estate Agent",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A880",
    name: "Proprietor - No Hazardous Duties",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A881",
    name: "Psychiatrist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A882",
    name: "Psychologist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A883",
    name: "Psychotherapist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A884",
    name: "Public Health Inspector",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A335",
    name: "Public Relations Officer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A336",
    name: "Publisher / Desktop Publisher",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A885",
    name: "Purchasing Officer/Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A337",
    name: "Quality Checker / Tester",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A886",
    name: "Quality Control Engineer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A887",
    name: "Quality Control Inspector",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A888",
    name: "Quantity Surveyor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A889",
    name: "Radar Controller/Operator",
    class: "CLS2",
    diiClass: "CLS1"
  },
  {
    code: "A890",
    name: "Radio Station Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A891",
    name: "Radio/TV Repairer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A414",
    name: "Radiologist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A892",
    name: "Radiotherapist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A893",
    name: "Rag & Bone Dealer",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A894",
    name: "Receptionist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A895",
    name: "Record Producer - Entertainment",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A896",
    name: "Recording Engineer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A338",
    name: "Recruitment Agency Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A897",
    name: "Recruitment Consultant/Associate",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A898",
    name: "Recycle Collector",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A899",
    name: "Reflexologist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A900",
    name: "Reinsurance Broker",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A901",
    name: "Relationship Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A339",
    name: "Remedial Therapist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A340",
    name: "Remisier / Stockbroker",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A902",
    name: "Reporter - Non Disaster/War Zone",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A903",
    name: "Research Chemist - Admin",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A904",
    name: "Research Survey Staff",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A905",
    name: "Reservations Officer/Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A341",
    name: "Reservoir Attendant / Worker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A906",
    name: "Restaurant Owner - No Cooking",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A907",
    name: "Retail Assistant",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A908",
    name: "Retail Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A342",
    name: "Retiree",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A909",
    name: "Rigger - Docks",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A910",
    name: "Rigger - Film Industry - Entertainment",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A911",
    name: "Rigger - Gas Supply Industry",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A912",
    name: "Rigger - Industrial/Plant Machinery",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A913",
    name: "Rigger - Oil & Gas (Offshore)",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A914",
    name: "Rigger - Ship & Marine Engineering",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A915",
    name: "Risk Management Specialist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A343",
    name: "Riveter",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A344",
    name: "Road Maintenance Worker",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A345",
    name: "Roofer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A916",
    name: "Safety Inspector",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A917",
    name: "Safety Officer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A918",
    name: "Sailing Instructor",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A346",
    name: "Sailor / Seaman",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A919",
    name: "Sales Director - Commission Based",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A920",
    name: "Sales Director - Management",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A348",
    name: "Sales Work - Not Office Based",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A347",
    name: "Sales Work - Office Based",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A349",
    name: "Salvage Vessel Crew / Officer",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A921",
    name: "Sandblaster",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A350",
    name: "Scaffolder",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A922",
    name: "Scene Shifter",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A923",
    name: "Scenery Painter",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A351",
    name: "Scientist - Others",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A352",
    name: "Scientist - Research Only",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A353",
    name: "Screen Printer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A924",
    name: "Screenmaker - Printing",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A925",
    name: "Secretary",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A926",
    name: "Security Consultant",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A016",
    name: "Security Guard/Officer-Armed",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A354",
    name: "Security Guard/Officer-Unarmed",
    class: "CLS3",
    diiClass: "CLS9"
  },
  {
    code: "A927",
    name: "Seismologist - Environment",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A355",
    name: "Sewerage Worker",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A356",
    name: "Ship Building / Repair Worker",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A357",
    name: "Ship Passenger Vessel - Crew",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A358",
    name: "Ship Passenger Vessel -Officer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A359",
    name: "Shipwright",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A360",
    name: "Shoe Maker",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A361",
    name: "Shoe Repairer",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A362",
    name: "Shop Keeper / Shop Worker",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A363",
    name: "Sign Writer",
    class: "CLS1",
    diiClass: "CLS3"
  },
  {
    code: "A928",
    name: "Silversmith",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A364",
    name: "Slaughterer",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A929",
    name: "Slaughterhouse Manager",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A930",
    name: "Social Welfare Officer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A365",
    name: "Social Worker",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A366",
    name: "Sociologist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A931",
    name: "Software Engineer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A932",
    name: "Solderer",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A933",
    name: "Solicitor",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A934",
    name: "Song Writer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A935",
    name: "Sorter - Scrap Metal",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A936",
    name: "Sound Balancer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A937",
    name: "Sound Mixer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A938",
    name: "Sound Recordist",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A939",
    name: "Sound Technician",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A940",
    name: "Special Effects Technician",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A367",
    name: "Speech Therapist",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A368",
    name: "Sports - Instructor/Trainer",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A941",
    name: "Sports Equipment Maker",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A942",
    name: "Sports Equipment Repairer",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A370",
    name: "Spray Painter",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A943",
    name: "Stage Doorkeeper",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A944",
    name: "Stage Hand",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A945",
    name: "Stage Manager",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A946",
    name: "Stage Technician",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A371",
    name: "Steel Worker",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A947",
    name: "Stenographer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A372",
    name: "Stevedore",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A948",
    name: "Stocktaker",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A949",
    name: "Stone Breaker",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A373",
    name: "Storeman - Docks",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A374",
    name: "Storeman - Factory / Plant",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A375",
    name: "Student",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A950",
    name: "Stunt Man",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A376",
    name: "Supplier",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A951",
    name: "Surveyor - Marine Engineering",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A952",
    name: "Surveyor - Non-Marine/Oil & Gas",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A953",
    name: "Surveyor - Oil & Gas (Offshore)",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A954",
    name: "Swimming Instructor",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A955",
    name: "Systems Programmer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A378",
    name: "Tailor / Dressmaker",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A379",
    name: "Tattooist",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A956",
    name: "Tax Consultant/Associate",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A957",
    name: "Tax Inspector",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A958",
    name: "Taxi Business Administrator",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A380",
    name: "Teacher - Non Qualified",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A381",
    name: "Teacher - Qualified",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A382",
    name: "Teaching Assistant",
    class: "CLS1",
    diiClass: "CLS3"
  },
  {
    code: "A383",
    name: "Technicians / Technologists",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A959",
    name: "Telecomm Tech Officer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A960",
    name: "Telephone Operator",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A961",
    name: "Test Engineer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A384",
    name: "Textile Industry Worker",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A962",
    name: "Theatre Sound Engineer",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A963",
    name: "Ticket Inspector",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A385",
    name: "Tiler - Floors / Walls",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A386",
    name: "Toolmaker",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A387",
    name: "Tour Guide / Attraction Guide",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A964",
    name: "Tower Crane Driver",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A965",
    name: "Town Planner",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A966",
    name: "Toxicologist",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A967",
    name: "Trader - Financial Instruments",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A968",
    name: "Traffic Warden",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A389",
    name: "Train / MRT Inspector ",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A391",
    name: "Train Carriage Maintenance",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A390",
    name: "Train Station Worker",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A392",
    name: "Train Track Maintenance Worker",
    class: "CLS3",
    diiClass: "CLS4"
  },
  {
    code: "A969",
    name: "Trainer-Edu - Office Based",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A226",
    name: "Translator - No Overseas Work",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A970",
    name: "Travel Agent - Office Based",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A393",
    name: "Travel Agent / Agency Staff",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A971",
    name: "Tree Surgeon",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A394",
    name: "Tugboat Operator",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A395",
    name: "Tutor - Private",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A972",
    name: "Tutor - Salaried",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A396",
    name: "Tyre Fitter",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A973",
    name: "Undertaker",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A974",
    name: "Underwriter",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A398",
    name: "Unemployed",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A399",
    name: "Upholsterer",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A975",
    name: "Usher - Theatre",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A976",
    name: "Valet/Valeter",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A400",
    name: "Valuer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A977",
    name: "Varnisher",
    class: "CLS3",
    diiClass: "CLS3"
  },
  {
    code: "A978",
    name: "Venture Capitalist",
    class: "CLS1",
    diiClass: "CLS9"
  },
  {
    code: "A401",
    name: "Veterinarian / Surgeon ",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A402",
    name: "Veterinarian Assistant",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A979",
    name: "Video Games Creator/Tester",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A980",
    name: "Vision Mixer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A403",
    name: "Waiter/Waitress",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A981",
    name: "Wardrobe Master/Mistress",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A982",
    name: "Warehouse Manager",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A404",
    name: "Warehouseman / Warehouse Work",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A983",
    name: "Washer - Food & Beverage",
    class: "CLS2",
    diiClass: "CLS3"
  },
  {
    code: "A984",
    name: "Website/Webpage Designer",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A405",
    name: "Welder - Other",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A406",
    name: "Welder - Spot Welding Only",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A407",
    name: "Welder / Flame Cutter",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A408",
    name: "Well Worker - Water Supply",
    class: "CLS4",
    diiClass: "CLS9"
  },
  {
    code: "A409",
    name: "Wholesaler",
    class: "CLS2",
    diiClass: "CLS2"
  },
  {
    code: "A985",
    name: "Window Dresser",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A410",
    name: "Wood Worker",
    class: "CLS4",
    diiClass: "CLS4"
  },
  {
    code: "A411",
    name: "Writer - Script / Technical",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A986",
    name: "X-ray Technician/Radiographer",
    class: "CLS1",
    diiClass: "CLS2"
  },
  {
    code: "A987",
    name: "Yoga Instructor",
    class: "CLS2",
    diiClass: "CLS9"
  },
  {
    code: "A988",
    name: "Zoo Curator",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A989",
    name: "Zoo Director",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A990",
    name: "Zoological Research Associate",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A991",
    name: "Zoological Researcher",
    class: "CLS1",
    diiClass: "CLS1"
  },
  {
    code: "A992",
    name: "Zoologist",
    class: "CLS1",
    diiClass: "CLS1"
  }
]